var styles = {"box":"View_box_11ce5_1","header":"View_header_11ce5_1","bottom-menu":"View_bottom-menu_11ce5_10","layout":"View_layout_11ce5_19","left-aside":"View_left-aside_11ce5_27","right-aside":"View_right-aside_11ce5_34","main-container":"View_main-container_11ce5_44","open":"View_open_11ce5_54","right-open":"View_right-open_11ce5_81","left-open":"View_left-open_11ce5_84"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
